import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useEffect, useState } from 'react';
import { MEDIALINK_SORTING_OPTION, MedialinkSorting } from '../browse/medialinkSortingOption';
import ModuleContext from './ModuleContext';

type MaterialFilterContextValue = {
  filterOnFavorites: boolean;
  toggleFavoriteFilter: () => void;
  medialinkSorting: MedialinkSorting;
  sortMedialinksOn: Dispatch<SetStateAction<MedialinkSorting>>;
  mediaContentTypeId?: string;
  filterMaterialOnMediaContentType: (mediaContentType: string) => void;
};

const MaterialFiltersContext = createContext<MaterialFilterContextValue>({
  filterOnFavorites: false,
  toggleFavoriteFilter: () => {},
  medialinkSorting: MEDIALINK_SORTING_OPTION.LESSON,
  sortMedialinksOn: () => {},
  mediaContentTypeId: undefined,
  filterMaterialOnMediaContentType: () => {},
});

export default MaterialFiltersContext;

export function MaterialFiltersContextProvider({ children }: PropsWithChildren) {
  const { selectedModule } = useContext(ModuleContext);

  const [filterOnFavorites, setFilterOnFavorites] = useState(false);
  const [medialinkSorting, sortMedialinksOn] = useState<MedialinkSorting>(
    selectedModule?.defaultSorting || MEDIALINK_SORTING_OPTION.LESSON,
  );
  const [mediaContentTypeId, filterMaterialOnMediaContentType] = useState<string>('');

  useEffect(() => {
    if (!selectedModule) return;

    const { defaultSorting } = selectedModule;

    if (defaultSorting) {
      sortMedialinksOn(defaultSorting);
    }
  }, [selectedModule]);

  const toggleFavoriteFilter = () => {
    setFilterOnFavorites(!filterOnFavorites);
  };

  return (
    <MaterialFiltersContext.Provider
      value={{
        filterOnFavorites,
        toggleFavoriteFilter,
        medialinkSorting,
        sortMedialinksOn,
        mediaContentTypeId,
        filterMaterialOnMediaContentType,
      }}
    >
      {children}
    </MaterialFiltersContext.Provider>
  );
}
